import { ModeStateType } from "../types/state-types";
import { TposMode } from "../types/mode";
import { ActionType } from "../types/action-types";
import { SELECT_AGGREGATOR, TOGGLE_MODE } from "../constants/actionTypesTpos";
import { CLEAR_BASKET_AFTER_ORDER } from "../constants/actionTypes";

export const INITIAL_STATE: ModeStateType = {
  tposMode: TposMode.DRIVE_THRU,
  printerName: "Intermec PR3",
};

const toggleMode = (state: ModeStateType) => {
  let tposMode = TposMode.DRIVE_THRU;
  let { selectedAggregator } = state;
  if (state.tposMode === TposMode.DRIVE_THRU) {
    tposMode = TposMode.AGGREGATOR;
    selectedAggregator = undefined;
  }
  return { ...state, tposMode, selectedAggregator };
};

const modeReducer = (
  state: ModeStateType = INITIAL_STATE,
  action: ActionType<any>,
): ModeStateType => {
  switch (action.type) {
    case SELECT_AGGREGATOR: {
      return { ...state, selectedAggregator: action.payload };
    }
    case TOGGLE_MODE: {
      return toggleMode(state);
    }
    case CLEAR_BASKET_AFTER_ORDER:
      return { ...state, selectedAggregator: undefined };
    default:
      return state;
  }
};

export default modeReducer;
